const widgetInstanceKeys = {
    widgetInstancesWithRole: ['widgetInstancesWithRole'] as const,
    widgetInstances: ['widgetInstances'] as const,
    widgetInstanceById: (id: string) => [...widgetInstanceKeys.widgetInstances, id] as const,
    widgetInstancesByClient: (id: string) => [...widgetInstanceKeys.widgetInstances, "client", id] as const,
    widgetInstancesByRole: (id: string) => [...widgetInstanceKeys.widgetInstances, "role", id] as const,
}

export default widgetInstanceKeys